import { render } from "./TermsOfExchangeAndRefundView.vue?vue&type=template&id=caef9b1e&scoped=true"
import script from "./TermsOfExchangeAndRefundView.vue?vue&type=script&lang=js"
export * from "./TermsOfExchangeAndRefundView.vue?vue&type=script&lang=js"

import "./TermsOfExchangeAndRefundView.vue?vue&type=style&index=0&id=caef9b1e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caef9b1e"]])

export default __exports__